import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { SalesProductPrice } from '../../uig-product.models';
import { UIGProductPriceCalculatorAdapter } from './uig-product-price-calculator.adapter';
import * as UIGProductPriceCalculatorActions from './uig-product-price-calculator.actions';

@Injectable()
export class UIGProductPriceCalculatorEffects {

    constructor(
        private actions$: Actions,
        private uigProductPriceCalculatorAdapter: UIGProductPriceCalculatorAdapter
    ) {}

    getProductPrice$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(UIGProductPriceCalculatorActions.getProductPrice),
        switchMap((action) =>
          this.uigProductPriceCalculatorAdapter
            .getProductPrice(
              action.productCode,
            )
            .pipe(
              map((updateProductPrice: SalesProductPrice) =>
              UIGProductPriceCalculatorActions.updateProductPriceSuccess
                ({
                  updateProductPrice,
                })
              ),
              catchError((error) =>
                of(
                  UIGProductPriceCalculatorActions.updateProductPriceFailure({
                    error,
                  })
                )
              )
            )
        )
      );
    });

    updateProductPrice$ = createEffect(() => {
        return this.actions$.pipe(
          ofType(UIGProductPriceCalculatorActions.updateProductPrice),
          switchMap((action) =>
            this.uigProductPriceCalculatorAdapter
              .updateProductPrice(
                action.bestPrice,
                action.productCode,
                action.userCustomUvpPrice,
                action.userCustomProfitMarginPercent,
                action.taxm1
              )
              .pipe(
                map((updateProductPrice: SalesProductPrice) =>
                UIGProductPriceCalculatorActions.updateProductPriceSuccess
                  ({
                    updateProductPrice,
                  })
                ),
                catchError((error) =>
                  of(
                    UIGProductPriceCalculatorActions.updateProductPriceFailure({
                      error,
                    })
                  )
                )
              )
          )
        );
    });
}